module.exports = __webpack_public_path__ + "static/media/react1Export.26b82f80.png";